// extracted by mini-css-extract-plugin
export var root = "PlasmicPostHeader-module--root--1om2-";
export var link = "PlasmicPostHeader-module--link--3pQUL";
export var slotBlogTitle = "PlasmicPostHeader-module--slotBlogTitle--3gJh2";
export var slotPostTitle = "PlasmicPostHeader-module--slotPostTitle--3O-m5";
export var slotDate = "PlasmicPostHeader-module--slotDate--auHam";